const readString = (value) => (typeof value === 'string' && value.trim() ? value.trim() : '');

/**
 * Read a sandbox preview id from a location search string or URLSearchParams.
 * Accepts `sandbox_id` (Apps view deep links) and `sandbox` (editor overlays).
 */
export const readSandboxPreviewFromSearch = (search) => {
  const params =
    typeof URLSearchParams !== 'undefined' && search instanceof URLSearchParams
      ? search
      : new URLSearchParams(readString(search).replace(/^\?/, ''));
  const sandboxId = readString(params.get('sandbox_id') || params.get('sandbox'));
  return sandboxId ? {
    sandbox_id: sandboxId,
    ...(params.get('overlay') || params.get('revision') ? { active_overlay_id: params.get('overlay') || params.get('revision') } : {}),
    ...(params.get('approval') ? { approval_id: params.get('approval') } : {}),
    ...(params.get('changes') === '1' ? { show_changes: true } : {}),
  } : null;
};

/** Drop deep-link sandbox keys so Exit preview can return to live. */
export const stripSandboxPreviewFromSearch = (search) => {
  const params =
    typeof URLSearchParams !== 'undefined' && search instanceof URLSearchParams
      ? new URLSearchParams(search)
      : new URLSearchParams(readString(search).replace(/^\?/, ''));
  params.delete('sandbox_id');
  params.delete('sandbox');
  params.delete('overlay');
  params.delete('artifact');
  params.delete('revision');
  params.delete('approval');
  params.delete('changes');
  return params.toString();
};

/** Append a location.search string to a path that may already include a query. */
export const withPreservedSearch = (path, search) => {
  const base = readString(path);
  const suffix = readString(search);
  if (!base || !suffix || suffix === '?') return base;
  const query = suffix.startsWith('?') ? suffix.slice(1) : suffix;
  if (!query) return base;
  return base.includes('?') ? `${base}&${query}` : `${base}?${query}`;
};
